import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useEffect } from "react";
import PropTypes from "prop-types";

export default function A_SimpleSelect(props) {
  let {
    id,
    label,
    defaultValue,
    options,
    optionLabel,
    optionValue,
    defaultMessage,
    onChange = () => {},
    style = {},
    error = false,
    helperText = "",
    size = "default",
    className = "",
    MenuProps = {
      getContentAnchorEl: null,
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
    }
  } = props;

  const [value, setValue] = React.useState(
    defaultValue == -1 ? -1 : defaultValue
  );

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const getOptions = () => {
    return options && Array.isArray(options)
      ? options.map((option, index) => (
          <MenuItem key={`option_${index}`} value={option[optionValue]}>
            {option[optionLabel] || ""}
          </MenuItem>
        ))
      : [];
  };

  const handleChange = (event) => {
    let { value } = event.target;
    setValue(value);
    onChange && onChange(value);
  };

  return (
    <FormControl
      style={{ marginBottom: 4, minWidth: 120, ...style }}
      variant="outlined"
      error={error}
      size={size}
      className={className}
    >
      <InputLabel id={label}>{label}</InputLabel>
      <Select
        labelId={label}
        id={id || "demo-simple-select-label"}
        name={id || "demo-simple-select-label"}
        value={value}
        defaultValue={defaultValue}
        label={label}
        onChange={handleChange}
        onKeyDown={(e) => e.stopPropagation()}
        MenuProps={MenuProps}
      >
        {defaultMessage && <MenuItem>{defaultMessage}</MenuItem>}
        {getOptions()}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

A_SimpleSelect.propTypes = {
  id: PropTypes.any,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  options: PropTypes.any,
  optionLabel: PropTypes.string,
  optionValue: PropTypes.string,
  defaultMessage: PropTypes.string,
  onChange: PropTypes.any,
  style: PropTypes.object,
  error: PropTypes.any,
  helperText: PropTypes.any,
  size: PropTypes.string,
  className: PropTypes.string,
  MenuProps: PropTypes.object
};
